<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { Button } from 'next/polaris/ui/button';
import PolarisMark from 'next/sidebar/PolarisMark.vue';
import {
  focusPanelTab,
  isConversationPanelMounted,
  useConversationPanel,
} from 'dashboard/composables/useConversationPanel';
import { useUISettings } from 'dashboard/composables/useUISettings';

// "Ask Polaris" in the top bar, on every page. It replaces the round floating button and the old per-page
// gates: it shows whenever Polaris is on for the account (`hasAskTab`, the same flag the launcher read).
// Inside an open conversation the panel is the Inspector, so it opens on its Ask tab; anywhere else it toggles
// the global panel. Both write the same settings the launcher and the conversation switch did.
const { t } = useI18n();
const { updateUISettings, markCopilotPanelOpenedByUser } = useUISettings();
const { hasAskTab, isAskOpen, showAsk, close } = useConversationPanel();

const label = computed(() => t('CONVERSATION.SIDEBAR.COPILOT'));

const onClick = () => {
  if (isConversationPanelMounted.value) {
    if (isAskOpen.value) close();
    else {
      showAsk();
      focusPanelTab();
    }
    return;
  }
  // Read before marking: marking flips `isCopilotPanelVisible` itself below xl (the only thing holding
  // it back there is the lack of this same flag), so the order matters, or this closes instead of opening.
  const wasOpen = isAskOpen.value;
  markCopilotPanelOpenedByUser();
  updateUISettings({
    is_copilot_panel_open: !wasOpen,
    is_contact_sidebar_open: false,
  });
};
</script>

<template>
  <Button
    v-if="hasAskTab"
    variant="ghost"
    size="sm"
    class="px-2 lg:px-2.5"
    :aria-label="label"
    :aria-expanded="isAskOpen"
    data-ask-polaris-opener
    @click="onClick"
  >
    <PolarisMark size="xs" />
    <span class="hidden lg:inline">{{ label }}</span>
  </Button>
  <template v-else />
</template>
